import React from 'react';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import SEO from '../common/SEO';
import BcrumbBannerOne from '../elements/breadcrumb/BcrumbBannerOne';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import ProcessOne from '../component/process/ProcessOne';
import AboutThree from '../component/about/AboutThree';
import AboutFour from '../component/about/AboutFour';
import AboutFive from '../component/about/AboutFive';
import SectionTitle from '../elements/section-title/SectionTitle';
import CountUp from 'react-countup';
import TrackVisibility from 'react-on-screen';
import { FaShieldAlt, FaCheckCircle, FaAward, FaBug } from 'react-icons/fa';


const securityStats = [
    { icon: <FaShieldAlt />, end: 50, suffix: "+", title: "VAPT Assessments Completed" },
    { icon: <FaCheckCircle />, end: 100, suffix: "%", title: "Client Satisfaction" },
    { icon: <FaAward />, end: 0, suffix: "", title: "OWASP Certified Methodology", isText: true },
    { icon: <FaBug />, end: 500, suffix: "+", title: "Vulnerabilities Identified & Remediated" }
];


const AboutUs = () => {

    return (
        <>
        <SEO title="About us" />
        <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <BcrumbBannerOne 
                title="A team of Creative Minds designing best Apps and Website for the World."
                paragraph ="At Odhav technologies, we make sure that alongside growth of the company, our employees and client grow by providing a great work-life Culture in the Industry."
                styleClass="thumbnail-4"
                
                />
                <AboutFour />
                <AboutThree />

                {/* Security-First Approach Section */}
                <div className="section section-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <SectionTitle 
                                    subtitle="Security-First Approach"
                                    title="Security is Built Into Everything We Do"
                                    description=""
                                    textAlignment="heading-left mb--20"
                                    textColor=""
                                />
                                <p>At Odhav Technologies, security is not an afterthought — it is built into everything we do. Our team includes experienced security engineers who specialize in application security assessments, VAPT (Vulnerability Assessment & Penetration Testing), and OWASP compliance audits. We help businesses across industries identify and remediate security vulnerabilities before they become real threats.</p>
                                <p>Our security practice follows internationally recognized frameworks including OWASP Top 10, OWASP ASVS, and NIST SP 800-53 to deliver assessment reports that meet enterprise and regulatory compliance requirements.</p>
                            </div>
                            <div className="col-lg-6">
                                <div className="row" style={{marginTop: '20px'}}>
                                    {securityStats.map((stat, index) => (
                                        <div className="col-sm-6" key={index}>
                                            <div className="single-counterup" style={{
                                                textAlign: 'center',
                                                padding: '30px 20px',
                                                marginBottom: '20px',
                                                background: '#f8f8f8',
                                                borderRadius: '12px'
                                            }}>
                                                <span style={{fontSize: '32px', color: 'var(--color-primary)', display: 'block', marginBottom: '10px'}}>
                                                    {stat.icon}
                                                </span>
                                                {stat.isText ? (
                                                    <h3 style={{fontSize: '18px', color: 'var(--color-primary)', marginBottom: '8px'}}>✓ Certified</h3>
                                                ) : (
                                                    <h2 className="count-number" style={{marginBottom: '8px'}}>
                                                        <TrackVisibility once>
                                                            {({isVisible}) => (
                                                                <span className="number count">
                                                                    {isVisible ? <CountUp end={stat.end} duration={1} /> : null}
                                                                </span>
                                                            )}
                                                        </TrackVisibility>
                                                        <span className="symbol">{stat.suffix}</span>
                                                    </h2>
                                                )}
                                                <span className="counter-title">{stat.title}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <AboutFive />
                <ProcessOne />
                <CtaLayoutOne />
                <FooterOne parentClass="" />
            </main>
        </>
    )
}

export default AboutUs;